import './src/styles/global.css';
import keyboardOnlyOutlines from '@moxy/keyboard-only-outlines'

keyboardOnlyOutlines()

console.log(`%c
  █████████
    ██████████
    ██████████
    ██████████
  █████████ █
`, 'font-size: 20px;  color: #EE4A34;')

// Save scroll position before unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    sessionStorage.setItem('scrollTimestamp', Date.now().toString());
  });
}

// Gatsby Browser API - called when the app first loads in the browser
export const onClientEntry = () => {
  const scrollPosition = sessionStorage.getItem('scrollPosition');
  const scrollTimestamp = sessionStorage.getItem('scrollTimestamp');

  // Only restore if the save was recent (within last 2 seconds)
  if (scrollPosition && scrollTimestamp) {
    const timeDiff = Date.now() - parseInt(scrollTimestamp, 10);

    if (timeDiff < 2000) {
      // Wait for page to be fully ready
      const restoreScroll = () => {
        window.scrollTo(0, parseInt(scrollPosition, 10));
        sessionStorage.removeItem('scrollPosition');
        sessionStorage.removeItem('scrollTimestamp');
      };

      // Try multiple times to ensure it works
      setTimeout(restoreScroll, 0);
      setTimeout(restoreScroll, 100);
      setTimeout(restoreScroll, 300);
    } else {
      // Clean up old data
      sessionStorage.removeItem('scrollPosition');
      sessionStorage.removeItem('scrollTimestamp');
    }
  }
};

// Prevent Gatsby from managing scroll position
export const shouldUpdateScroll = () => {
  return false;
};